var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#222222",
    fillRule: "evenodd",
    transform: "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9906311,10 C21.5480902,10 22,10.4433532 22,11.0093689 L22,12.9906311 C22,13.5480902 21.5566468,14 20.9906311,14 L18,14 L18,10 L20.9906311,10 Z M17,10 L17,14 L4.33333333,14 L2,12 L4.33333333,10 L17,10 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.dbf820cf582324bb65f52dd757583741.svg";
export { ForwardRef as ReactComponent };